import i18n from '@/config/translation'

export const DEFAULT_USER_GROUP_LABEL = 'Groupe'

const DEFAULT_LABELS_BY_LOCALE = {
	fr: 'Groupe',
	en: 'Group',
} as const

export const resolveUserGroupLabel = (firm?: {
	options?: {
		labels?: {
			userGroup?: string | null
		} | null
	} | null
} | null): string => {
	const stored = firm?.options?.labels?.userGroup
	if (typeof stored === 'string' && stored.trim())
		return stored.trim()
	return DEFAULT_USER_GROUP_LABEL
}

/** Overrides `common.labels.userGroup` so all linked i18n messages pick up the firm label. */
export const applyUserGroupLabels = (firm?: Parameters<typeof resolveUserGroupLabel>[0]) => {
	const stored = firm?.options?.labels?.userGroup
	const customLabel = typeof stored === 'string' ? stored.trim() : ''

	i18n.global.mergeLocaleMessage('fr', {
		common: {
			labels: {
				userGroup: customLabel || DEFAULT_LABELS_BY_LOCALE.fr,
			},
		},
	})
	i18n.global.mergeLocaleMessage('en', {
		common: {
			labels: {
				userGroup: customLabel || DEFAULT_LABELS_BY_LOCALE.en,
			},
		},
	})

	return customLabel || DEFAULT_USER_GROUP_LABEL
}
